export default __webpack_public_path__ + "static/mondelez-f230605d60b51bbe5b37dbcea36d1557.webm";